import { render, staticRenderFns } from "./NotificationsTemplates.vue?vue&type=template&id=a1890238&"
import script from "./NotificationsTemplates.vue?vue&type=script&lang=js&"
export * from "./NotificationsTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports